import { BaseLayout } from "components/Layouts/BaseLayout/BaseLayout.tsx";
import { usePageMeta } from "hooks/usePageMeta";
import { FC, PropsWithChildren } from "react";

export const AccountLayout: FC<PropsWithChildren> = ({ children }) => {
    usePageMeta("Paldock");
    return <BaseLayout>{children}</BaseLayout>;
};
